export const abstract =
  'REZITRADE is transforming residential real estate with a unique index-based platform offering Home Price Protection.'
